<template>
  <div class="page-wrapper">
    <HeaderComponent />

    <div class="page-content">
      <AppBreadcrumb :items="[{ label: 'Natija' }]" />

      <a-alert
        v-if="errorMessage"
        type="error"
        show-icon
        :message="errorMessage"
        style="margin-bottom: 16px"
      />

      <template v-if="loading">
        <a-card class="custom-card result-card">
          <a-skeleton active />
        </a-card>
      </template>

      <template v-else-if="result">
        <div class="result-wrap">
          <a-card class="custom-card result-card">
            <div class="result-top">
              <div class="result-icon">
                {{ result.failedByMistakes ? '⚠️' : '✅' }}
              </div>

              <div>
                <h1 class="result-title">
                  {{ result.failedByMistakes ? 'Test muddatidan oldin yakunlandi' : 'Test yakunlandi' }}
                </h1>
                <p class="result-subtitle">
                  {{ result.title }}
                </p>
              </div>
            </div>

            <a-row :gutter="[16,16]" style="margin-top: 18px;">
              <a-col :xs="24" :md="12" :xl="6">
                <div class="stat-box">
                  <div class="stat-label">Jami savollar</div>
                  <div class="stat-value">{{ result.totalQuestions }}</div>
                </div>
              </a-col>

              <a-col :xs="24" :md="12" :xl="6">
                <div class="stat-box success-box">
                  <div class="stat-label">To‘g‘ri</div>
                  <div class="stat-value">{{ result.correctCount }}</div>
                </div>
              </a-col>

              <a-col :xs="24" :md="12" :xl="6">
                <div class="stat-box danger-box">
                  <div class="stat-label">Xato</div>
                  <div class="stat-value">{{ result.wrongCount }}</div>
                </div>
              </a-col>

              <a-col :xs="24" :md="12" :xl="6">
                <div class="stat-box primary-box">
                  <div class="stat-label">Foiz</div>
                  <div class="stat-value">{{ result.percent }}%</div>
                </div>
              </a-col>
            </a-row>

            <div class="result-progress">
              <div class="result-progress-head">
                <span>Natija ko‘rsatkichi</span>
                <span>{{ result.percent }}%</span>
              </div>
              <a-progress :percent="Number(result.percent)" :show-info="false" />
            </div>

            <div v-if="result.unansweredCount > 0" class="info-note">
              Javobsiz qolgan savollar soni: {{ result.unansweredCount }}
            </div>

            <div v-if="result.failedByMistakes" class="warning-note">
              Real imtihonda 3 ta xato qilinganligi sababli test avtomatik yakunlandi.
            </div>

            <div class="result-actions">
              <a-button type="primary" size="large" @click="restartTest">
                Qayta ishlash
              </a-button>

              <a-button
                v-if="showBackToCategory"
                size="large"
                @click="goBackToCategory"
              >
                Kategoriyaga qaytish
              </a-button>

              <a-button v-else size="large" @click="goHome">
                Bosh sahifa
              </a-button>
            </div>
          </a-card>
        </div>
      </template>

      <template v-else>
        <a-empty description="Natija topilmadi">
          <a-button type="primary" @click="goHome">Bosh sahifa</a-button>
        </a-empty>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'

export default {
  name: 'ResultView',

  components: {
    HeaderComponent,
    AppBreadcrumb
  },

  data() {
    return {
      backendUrl: 'https://avtotesting.uz/api',
      loading: true,
      errorMessage: '',
      result: null
    }
  },

  computed: {
    resultId() {
      return Number(this.$route.query.result_id) || null
    },

    showBackToCategory() {
      return this.result?.backRoute?.startsWith('/tickets/')
    }
  },

  async created() {
    if (!this.resultId) {
      this.errorMessage = "Natija identifikatori topilmadi"
      this.loading = false
      return
    }

    await this.fetchResult()
  },

  methods: {
    getAuthHeaders() {
      const token = localStorage.getItem('accessToken') || ''
      return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    },

    async fetchResult() {
      this.loading = true
      this.errorMessage = ''
      this.result = null

      try {
        const response = await axios.get(
          `${this.backendUrl}/v1/tests/result/${this.resultId}/`,
          { headers: this.getAuthHeaders() }
        )

        const data = response.data?.result || response.data || {}

        this.result = {
          title:
            data.title ||
            data.ticket_name ||
            (data.ticket_size && data.ticket_number
              ? `${data.ticket_size} talik bilet #${data.ticket_number}`
              : 'Test natijasi'),

          totalQuestions: Number(data.total_questions || data.total || 0),
          correctCount: Number(data.correct_count || data.correct || 0),
          wrongCount: Number(data.wrong_count || data.wrong || 0),
          unansweredCount: Number(data.unanswered_count || data.unanswered || 0),
          percent: Number(data.score_percent || data.percent || 0),

          failedByMistakes: !!data.failed_by_mistakes,

          backRoute:
            data.back_route ||
            (data.ticket_size ? `/tickets/${data.ticket_size}` : '/')
        }
      } catch (error) {
        console.error('Natija yuklash xatosi:', error)
        this.errorMessage =
          error?.response?.data?.detail ||
          error?.response?.data?.message ||
          'Natijani serverdan olishda xatolik'
      } finally {
        this.loading = false
      }
    },

    goHome() {
      this.$router.push('/')
    },

    restartTest() {
      if (this.result?.backRoute && this.result.backRoute !== '/') {
        this.$router.push(this.result.backRoute)
      } else {
        this.$router.push('/')
      }
    },

    goBackToCategory() {
      if (this.result?.backRoute?.startsWith('/tickets/')) {
        this.$router.push(this.result.backRoute)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


.result-wrap {
  width: 1000px;
  margin: 0 auto;
}

.result-card {
  padding: 10px;
}

.result-top {
  display: flex;
  align-items: center;
  gap: 16px;
}

.result-icon {
  width: 74px;
  height: 74px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  background: linear-gradient(135deg, rgba(59,130,246,0.18), rgba(29,78,216,0.24));
  border: 1px solid var(--border);
}

.result-title {
  margin: 0;
  font-size: 30px;
  color: var(--text);
}

.result-subtitle {
  margin: 8px 0 0;
  color: var(--text-soft);
  font-size: 15px;
}

.stat-box {
  border-radius: 18px;
  padding: 18px;
  border: 1px solid var(--border);
  background: rgba(255,255,255,0.03);
}

.stat-label {
  color: var(--text-soft);
  font-size: 14px;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 30px;
  font-weight: 800;
  color: var(--text);
}

.success-box {
  background: rgba(34,197,94,0.10);
}

.danger-box {
  background: rgba(239,68,68,0.10);
}

.primary-box {
  background: rgba(59,130,246,0.10);
}

.result-progress {
  margin-top: 24px;
}

.result-progress-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: var(--text);
  font-weight: 700;
}

.info-note {
  margin-top: 18px;
  border: 1px solid rgba(59, 130, 246, 0.35);
  background: rgba(59, 130, 246, 0.12);
  color: var(--text);
  padding: 14px 16px;
  border-radius: 16px;
  line-height: 1.6;
}

.warning-note {
  margin-top: 18px;
  border: 1px solid rgba(245, 158, 11, 0.35);
  background: rgba(245, 158, 11, 0.12);
  color: #fcd34d;
  padding: 14px 16px;
  border-radius: 16px;
  line-height: 1.6;
}

.result-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  flex-wrap: wrap;
}
</style>